export default __webpack_public_path__ + "static/beumer-3cbbba46370e99891d83f868ba7a0e04.jpg";